import React from 'react';
import { Flex, Heading } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import './header.css';
import HeaderImg from "../images/header.png"

const Header = () => {
  return (
    <Flex
      as="header"
      align="center"
      justify="space-between"
      bg="teal.400"
      color="white"
      minHeight="200px"
      position="relative"
      direction={{ base: 'column', md: 'row' }}
    >
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{ transform: 'translate(-50%, -50%)' }}
      >
        <div>
          <Heading
            as="h1"
            size="xl"
            textAlign="center"
            textShadow="2px 2px 4px rgba(0, 0, 0, 0.3)"
            className="rainbow-text"
          >
            Harmonize Words, Magnify Wisdom:
          </Heading>
          <p className="header-p">
            Introducing Summerize - An AI based Text Summarizer Companion. Our summarizer app efficiently condenses lengthy content, providing concise and relevant summaries. Extract key points from articles, documents, or web pages swiftly, enhancing productivity and comprehension.
          </p>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="header-image-container"
      >
        <img
          src={HeaderImg}
          alt="Header Illustration"
          className="header-image"
        />
      </motion.div>
    </Flex>
  );
};

export default Header;
